<template>
  <div class="page-box">
    <PageSwiper location="HONOR" />

    <div class="page-nav">
      <img src="@/assets/home-icon.png" @click="gotoHome" />
      <div style="cursor: pointer" @click="gotoHome">首页 ></div>
      <div class="text">资质荣誉</div>
    </div>

    <div class="honor-box honor-border">
      <div class="title-row">
        <div class="title">资质证书</div>
      </div>
      <div class="honor-content">
        <div class="honor-item" v-for="(item, index) in certs" :key="index">
          <img :src="$utils.getFileHttpUrl(item.img)" />
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="honor-box">
      <div class="title-row">
        <div class="title">荣誉证书</div>
      </div>
      <div class="honor-content">
        <div class="honor-item" v-for="(item, index) in honors" :key="index">
          <img :src="$utils.getFileHttpUrl(item.img)" />
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageSwiper from '@/components/PageSwiper'
export default {
  components: { PageSwiper },
  data() {
    return {
      certs: [],
      honors: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    gotoHome() {
      this.$router.replace({ name: 'home' })
    },
    getData() {
      this.$http.getAction('/portal/api/v1/honor').then((res) => {
        if (res.success) {
          this.certs = res.data.certs
          this.honors = res.data.honors
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-box {
  padding-bottom: 60px;

  .page-nav {
    display: flex;
    align-items: center;
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    font-weight: 500;
    font-size: 14px;
    color: #898989;
    line-height: 16px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 15px;
      cursor: pointer;
    }
    .text {
      padding-left: 6px;
      color: #333333;
    }
  }

  .honor-box {
    width: 1200px;
    margin: 0 auto;
    .title-row {
      margin: 30px 0 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        height: 40px;
        font-weight: 800;
        font-size: 24px;
        color: #0282de;
        line-height: 40px;
      }
    }
    .honor-content {
      display: flex;
      flex-wrap: wrap;
      .honor-item {
        width: 380px;
        margin-right: 30px;
        &:nth-of-type(3n) {
          margin-right: 0;
        }
        img {
          width: 380px;
          height: 270px;
          object-fit: cover;
        }
        .name {
          width: 380px;
          height: 95px;
          line-height: 95px;
          font-weight: 500;
          font-size: 18px;
          color: #000000;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .honor-border {
    border-bottom: 1px solid #D4D7D9;

  }
}
</style>
